import { formatFileSize } from 'utils/formatFileSize';
import { getPrevPage } from 'utils/prevPath';

import type { ApiFile } from 'ts/types/file';

type TParams = {
  success: boolean;
  fileData?: ApiFile;
  place?: string;
  isManual: boolean;
  inputFile?: { size: number };
  fileId?: string;
};

export function generateDownloadAnalyticsData({ success, fileData, place, isManual, inputFile, fileId }: TParams) {
  return {
    fromPage: getPrevPage(),
    status: success ? 'success' : 'fail',
    method: isManual ? 'manual' : 'auto',
    fileId,
    place,
    ...(inputFile ? { input_file_size: inputFile.size / 1000000 } : {}),
    ...(fileData
      ? {
          exact_file_size: fileData.size / 1000000,
          file_size: fileData && formatFileSize(parseInt('' + fileData.size || '0')),
          format: fileData.internal_type,
          file_name: fileData.filename
        }
      : {})
  };
}
